<template>
  <div>
    <Modal v-model="visible" :title="title" :footer-hide="true" :mask-closable="false" width="1200"
      class="my-modal p-b top template-user-detail">
      <div class="table-box">
        <loading :isShow="tableLoading" />
        <Table :columns="key ? this[key] : {}" :data="tableData">
          <template slot-scope="{ row }" slot="status">
            <div>{{ $dic.mechanStatus[row.status] }}</div>
          </template>
          <template slot-scope="{ row }" slot="leaderName">
            <div>{{ row.leaderName || '-' }}</div>
          </template>
          <template slot-scope="{ row }" slot="merchantStatus">
            <div v-if="row.status == 1">有效</div>
            <div v-if="row.status == 0">失效</div>
          </template>
          <template slot-scope="{ row }" slot="action">
            <div>
              <span class="table-btn" @click="goTemplateDetail(row)" v-if="key == 'mechan'">查看机构费率</span>
              <span class="table-btn" @click="goTemplateDetail(row)" v-else-if="key == 'team'">查看团队费率</span>
              <span class="table-btn" @click="goTemplateDetail(row)" v-else>查看费率</span>
              <span class="table-btn" @click="deleteTemplate(row)" v-if="workName!='workName'">删除</span>
            </div>
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
          style="text-align: center; margin-top: 20px" />
        <div class="btn-list" v-if="workName!='workName'">
          <Button type="primary" v-if="key == 'mechan'" @click="addOrgTeam">添加机构</Button>
          <Button type="primary" v-else @click="addOrgTeam">添加团队</Button>
        </div>
      </div>
    </Modal>

    <!-- 添加团队/机构 -->
    <templateUserSelectOrganTeam ref="selsetOrganTeam" :detail="detail" @success="successAddOrgaTeam">
    </templateUserSelectOrganTeam>
  </div>
</template>

<script>
import templateUserSelectOrganTeam from './templateUserSelectOrganTeam';
import { common } from '@/api/mixins';
export default {
  props:['workName'],
  mixins: [common],
  data() {
    return {
      detail:{},
      companyList: [{value:1}],//保险公司
      tableLoading: false,//表格loading
      loading:false,
      //表格字段
      mechan: [
        {
          title: "机构ID",
          key: "id",
          align: "center",
          width: 180
        },
        {
          title: "机构名称",
          key: "name",
          minWidth: 200,
          align: "center",
        },
        {
          title: "机构等级",
          key: "levelName",
          align: "center",
          minWidth: 120
        },
        {
          title: "机构状态",
          slot: "status",
          align: "center",
          minWidth: 100
        },
        {
          title: "负责人",
          slot: "leaderName",
          align: "center",
          minWidth: 100
        },
        {
          title: "上级机构",
          key: "parentName",
          align: "center",
          minWidth: 150
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 200
        },
      ],
      team: [
        {
          title: "团队名称",
          key: "name",
          align: "center",
          minWidth: 200,
        },
        {
          title: "所属机构",
          key: "parentOrgName",
          align: "center",
        },
        {
          title: "团队人数",
          key: "num",
          align: "center",
        },
        {
          title: "团队长",
          slot: "leaderName",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 200
        },
      ],
      top: [
        {
          title: "商户号",
          key: "merchantNo",
          align: "center",
        },
        {
          title: "商户简称",
          key: "merchantName",
          align: "center",
        },
        {
          title: "商户状态",
          slot: "merchantStatus",
          align: "center",
        },
        {
          title: "负责人",
          key: "contact",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 250
        },
      ],
      key:"mechan",//mechan 机构字段 team团队字段
      tableData: [{ id: 1 }],//表格数据
      total: 0,//表格记录数
      pageSize: 10,//页容量
      pageNum: 1,//当前页
      title: "",
      visible: false,
      formVisible: false,
      orgList:[],
      userList:[],//所有商户
      form:{},
    };
  },

  components: {
    templateUserSelectOrganTeam
  },

  methods: {
    // 获取所有商户
    getAllUserList() {
      this.$http({
        url: '/buz/organizationTemplate/queryAddMerchant',
        type: 'get',
        data: {
          templateId: this.detail.id
        }
      }).then(res => {
        res.data.forEach(item => {
          item.key = item.id;
          item.label = item.name;
        });
        this.userList = res.data;
      });
    },

    // 添加机构/团队成功
    successAddOrgaTeam() {
      this.searchAjax();
      this.$emit('success');
    },

    // 跳转模板详情
    goTemplateDetail(item) {
      this.visible = false;
      if (this.key == 'mechan' || this.key == 'team') {
        this.openPageTabTags(
            '/productResource/fee/config', 
            {
              id: item.id
            }
        );
      } else {
        this.openPageTabTags(
            '/productResource/fee/config/templateDetail', 
            {
              id: this.detail.id
            }
        );
      }
    },

    // 添加机构/团队
    addOrgTeam() {
      if(!this.$units.pointAction('commission_20_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$refs.selsetOrganTeam.open(this.key);
    },

    // 删除
    deleteTemplate(row) {
      if(!this.$units.pointAction('commission_20_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      let type = this.detail.type;
      let name = '';
      if (type == 1) {
        name = '机构';
      } else if (type == 2) {
        name = '团队';
      } else {
        name = '商户';
      }

      this.$notice.inquiry(
        `删除后，该${name}将不再应用任何模板，是否删除？<div style='color:#a39f9f;margin-top:5px;font-size:14px;'>注：删除不会改变${name}现在的费率</div>`
      ).then(() => {
        this.$http({
          url: '/buz/organizationTemplate/cancel',
          type: 'POST',
          data: {
            organizationId: row.id,
            organizationType: this.detail.type,
            templateId: this.detail.id
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.searchAjax();
          this.$emit('success');
        });
      });
    },

    open(item) {
      this.detail = item;
      if (item.type == 1) {
        this.title = `使用模板“${this.detail.name}”的机构`;
        this.key = 'mechan';
      } else if (item.type == 2) {
        this.title = `使用模板“${this.detail.name}”的团队`;
        this.key = 'team';
      } else {
        this.title = `使用模板“${this.detail.name}”的商户`;
        this.key = 'top';
      }
      this.searchAjax();
      this.visible = true;
    },

    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },

    getList() {
      if (this.detail.type == 1) {
        this.getMechanList();
      } else if (this.detail.type == 2) {
        this.getTeamList();
      } else {
        this.getTopList();
      }
    },

    // 获取使用模板的商户
    getTopList() {
      const params = {
        templateId: this.detail.id,
        pageNo: this.pageNum,
        pageSize: this.pageSize
      };
      this.$http({
        url: '/buz/organizationTemplate/queryMerchant',
        type: 'get',
        data: params
      }).then(res => {
        this.tableData = res.data;
        this.total = res.total;
      });
    },

    // 获取使用模板的机构
    getMechanList() {
      const params = {
        templateId: this.detail.id,
        pageNo: this.pageNum,
        pageSize: this.pageSize
      };
      this.$http({
        url: '/buz/organizationTemplate/queryApplyOrg',
        type: 'get',
        data: params
      }).then(res => {
        this.tableData = res.data;
        this.total = res.total;
      });
    },

    // 获取使用模板的团队
    getTeamList() {
      const params = {
        templateId: this.detail.id,
        pageNo: this.pageNum,
        pageSize: this.pageSize
      };
      this.$http({
        url: '/buz/organizationTemplate/queryApplyGroup',
        type: 'get',
        data: params
      }).then(res => {
        this.tableData = res.data;
        this.total = res.total;
      });
    },

    // 模板新增用户弹窗
    openNoTempUserList() {
      this.$refs.selsetOrganTeam.open(this.key);
    }
  }
};
</script>
<style lang="scss">
@import './templateUserDetail.scss';
</style>